import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "evrideo-tot-sliding-toggle",
  templateUrl: "./tot-sliding-toggle.component.html",
  styleUrl: "./tot-sliding-toggle.component.scss",
})
export class TotSlidingToggleComponent implements OnChanges {
  @Input("this") itsThis: string;
  @Input("that") itsThat: string;
  @Input("default") selected: "this" | "that" = "this";
  @Input() disabled: boolean = false;
  @Input() disabledTooltip: string =
    "This feature is not available in this mode";
  // Color control inputs
  @Input() textColor?: string;
  @Input() toggleBorderColor?: string;
  @Input() toggleBallColor?: string;

  @Output() its: EventEmitter<string> = new EventEmitter<string>();

  state: boolean;

  ngOnInit() {
    this.updateState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["selected"] && !changes["selected"].firstChange) {
      this.updateState();
    }
  }

  private updateState() {
    this.state = this.selected === "that";
  }

  onChange(event: any) {
    this.state = event.target.checked;
    this.its.emit(this.state ? this.itsThat : this.itsThis);
  }
}
